import { format } from 'date-fns';
import type { FormEditor } from 'library/types/events';
import toBase64 from './toBase64';

const normalizeEvent = async (event: FormEditor) => {
  console.log(event.timetable);
  const data = {
    ...event,
    event_image: event.event_image !== '' ? event.event_image : undefined,
    address:
      event.mode === 'O'
        ? {
            ...event.address,
            image1:
              event.address?.image1 instanceof FileList && event.address.image1.length
                ? await toBase64(event.address?.image1.item(0))
                : undefined,
            image2:
              event.address?.image2 instanceof FileList && event.address.image2.length
                ? await toBase64(event.address.image2.item(0))
                : undefined,
            image3:
              event.address?.image3 instanceof FileList && event.address.image3.length
                ? await toBase64(event.address.image3.item(0))
                : undefined,
          }
        : undefined,
    cost: Number(event.cost) * 100,
    prepayment_cost: event.prepayment_cost * 100,
    event_coach: event.event_coach?.length
      ? event.event_coach.map((coach) => {
          return {
            ...coach,
            photo: coach.photo ? coach.photo : undefined,
          };
        })
      : [],
    event_block: event.event_block?.length
      ? event.event_block.map((block) => {
          return {
            ...block,
            image: block.image ? block.image : undefined,
          };
        })
      : [],
    time_from: event.timetable[0].time_from.toISOString(),
    time_to:
      event.timetable.length > 0
        ? event.timetable.at(-1)!.time_to!.toISOString()
        : event.timetable[0].time_to!.toISOString(),
    timetable: event.timetable?.map((day) => {
      return {
        date: format(day.time_from!, 'dd.MM.yyyy'),
        time_from: format(day.time_from!, 'HH:mm'),
        time_to: format(day.time_to!, 'HH:mm'),
      };
    }),
  };
  return data;
};

export default normalizeEvent;
